import { api } from "@/lib/api";
import { toast } from "sonner";

export const ImportReport = ({ report, prefix = "import" }) => {
  if (!report) return null;
  const downloadBackup = async () => {
    try {
      const { data } = await api.get(`/competitors/import-backups/${report.backup_id}`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const link = document.createElement("a"); link.href = url; link.download = `roster-backup-${report.backup_id}.json`;
      link.click(); URL.revokeObjectURL(url);
    } catch { toast.error("Could not download the backup. Please try again."); }
  };
  return <div className="mt-4 rounded-xl border border-slate-200 bg-white p-4 text-sm" data-testid={`${prefix}-report`}>
    <p data-testid={`${prefix}-counts`}>{report.created} created · {report.updated || 0} updated · {report.skipped || 0} unchanged · {report.review?.length || 0} need review</p>
    {report.backup_id && <button type="button" onClick={downloadBackup} className="mt-2 font-semibold underline text-[#B36906]" data-testid={`${prefix}-backup`}>Download pre-import backup</button>}
    {!!report.review?.length && <ul className="mt-3 space-y-2 text-amber-800 max-h-64 overflow-auto" data-testid={`${prefix}-review-list`}>{report.review.map((row, index) => <li key={`${row.row}-${index}`} data-testid={`${prefix}-review-${index}`}>Row {row.row}{row.name ? ` (${row.name})` : ""}: {row.reason}{row.fields?.length ? ` — ${row.fields.join(", ")}` : ""}</li>)}</ul>}
  </div>;
};
